var _a, _b;
export var EClientType;
(function (EClientType) {
    EClientType["Broker"] = "BROKER";
    // cspell:ignore PATRIMONYCOMPANY
    EClientType["PatrimonyCompany"] = "PATRIMONYCOMPANY";
    EClientType["Partner"] = "PARTNER";
})(EClientType || (EClientType = {}));
export var EIntakeType;
(function (EIntakeType) {
    EIntakeType[EIntakeType["TwoPhases"] = 1] = "TwoPhases";
    EIntakeType[EIntakeType["OnePhase"] = 2] = "OnePhase";
    EIntakeType[EIntakeType["TwoPhasesWithVisit"] = 3] = "TwoPhasesWithVisit";
})(EIntakeType || (EIntakeType = {}));
export var EBrokerFeature;
(function (EBrokerFeature) {
    EBrokerFeature["Bookkeeping"] = "BOOKKEEPING";
    EBrokerFeature["CalendarSync"] = "CALENDAR_SYNC";
    EBrokerFeature["CompleteContractFlow"] = "COMPLETE_CONTRACT_FLOW";
    EBrokerFeature["DuplicateContacts"] = "DUPLICATE_CONTACTS";
    EBrokerFeature["EnableBanqup"] = "ENABLE_BANQUP";
    EBrokerFeature["EnableCompaniesInBanqup"] = "ENABLE_COMPANIES_IN_BANQUP";
    EBrokerFeature["EnableLinkingProperties"] = "ENABLE_LINKING_PROPERTIES";
    EBrokerFeature["ExternalPaymentProcessing"] = "EXTERNAL_PAYMENT_PROCESSING";
    EBrokerFeature["HideFromRentMatchSearch"] = "HIDE_FROM_RENT_MATCH_SEARCH";
    EBrokerFeature["Ibanisation"] = "IBANISATION";
    EBrokerFeature["Insurance"] = "INSURANCE";
    EBrokerFeature["IntakeIncludeIncomeStatement"] = "INTAKE_INCLUDE_INCOME_STATEMENT";
    EBrokerFeature["IntakeIncomeOptional"] = "INTAKE_INCOME_OPTIONAL";
    EBrokerFeature["Invoicing"] = "INVOICING";
    EBrokerFeature["LatePaymentPenalty"] = "LATE_PAYMENT_PENALTY";
    EBrokerFeature["Mcp"] = "MCP";
    EBrokerFeature["PaymentV2"] = "PAYMENT_V2";
    EBrokerFeature["PayoutRentAndCostsTogether"] = "PAYOUT_RENT_AND_COSTS_TOGETHER";
    EBrokerFeature["PropertyInspectionReport"] = "PROPERTY_INSPECTION_REPORT";
    EBrokerFeature["RentDiscount"] = "RENT_DISCOUNT";
    EBrokerFeature["RentioLegal"] = "RENTIO_LEGAL";
    EBrokerFeature["RentioMove"] = "RENTIO_MOVE";
    EBrokerFeature["RentMatch"] = "RENT_MATCH";
    EBrokerFeature["TenantEndingNotification"] = "TENANT_ENDING_NOTIFICATION";
})(EBrokerFeature || (EBrokerFeature = {}));
export var EBrokerUsageStatus;
(function (EBrokerUsageStatus) {
    EBrokerUsageStatus["Green"] = "green";
    EBrokerUsageStatus["Orange"] = "orange";
    EBrokerUsageStatus["Red"] = "red";
})(EBrokerUsageStatus || (EBrokerUsageStatus = {}));
export var EBrokerBookkeepingSyncType;
(function (EBrokerBookkeepingSyncType) {
    EBrokerBookkeepingSyncType["Charge"] = "CHARGE";
    EBrokerBookkeepingSyncType["Payout"] = "PAYOUT";
})(EBrokerBookkeepingSyncType || (EBrokerBookkeepingSyncType = {}));
export var EIntegratorIds;
(function (EIntegratorIds) {
    EIntegratorIds["Dewaele"] = "1";
    EIntegratorIds["Zabun"] = "2";
    EIntegratorIds["EraForce"] = "3";
    EIntegratorIds["ImmoZone"] = "4";
    EIntegratorIds["Rentio"] = "5";
    EIntegratorIds["Newgate"] = "6";
})(EIntegratorIds || (EIntegratorIds = {}));
// Scopes that can be granted on a broker API key. Must stay in sync with the backend
// EScope enum (rentio-api-next src/models/auth/accessToken.types.ts) and with
// GRANTABLE_SCOPES in createBrokerApiKey.dto.ts — the API rejects any value it does not
// recognize.
//
// Every scope here grants something. There is no marker scope: a row is marked as a machine
// token by the isBroker column, so the key carries only what it is actually allowed to do.
// cspell:disable
export var EBrokerScopes;
(function (EBrokerScopes) {
    EBrokerScopes["ContactsRead"] = "contacts:read";
    EBrokerScopes["ContactsWrite"] = "contacts:write";
    EBrokerScopes["ContractsRead"] = "contracts:read";
    EBrokerScopes["ContractsWrite"] = "contracts:write";
    EBrokerScopes["CrmDewaele"] = "crm:dewaele";
    EBrokerScopes["CrmEraForce"] = "crm:eraforce";
    EBrokerScopes["CrmGeneric"] = "crm:generic";
    EBrokerScopes["CrmMaxImmo"] = "crm:maximmo";
    EBrokerScopes["CrmOmnicasa"] = "crm:omnicasa";
    EBrokerScopes["CrmRealSuite"] = "crm:realsuite";
    EBrokerScopes["CrmSkarabee"] = "crm:skarabee";
    EBrokerScopes["CrmSweepbright"] = "crm:sweepbright";
    EBrokerScopes["CrmWhise"] = "crm:whise";
    EBrokerScopes["CrmZabun"] = "crm:zabun";
    EBrokerScopes["PaymentOrdersRead"] = "payment-orders:read";
    EBrokerScopes["PaymentRequestsRead"] = "payment-requests:read";
    EBrokerScopes["PropertiesRead"] = "properties:read";
    EBrokerScopes["PropertiesWrite"] = "properties:write";
})(EBrokerScopes || (EBrokerScopes = {}));
// cspell:enable
export var ESsoProvider;
(function (ESsoProvider) {
    ESsoProvider["MicrosoftEntraId"] = "MICROSOFT_ENTRA_ID";
})(ESsoProvider || (ESsoProvider = {}));
// A key is either a CRM integration key or a custom-scoped one, never both: a CRM token's
// grant is fixed by the vendor, and mixing it with resource scopes would describe a token
// the API has no way to honor differently. The form picks the kind first.
// Exactly one of these per CRM key.
export var BROKER_CRM_SCOPES = [
    EBrokerScopes.CrmGeneric,
    EBrokerScopes.CrmDewaele,
    EBrokerScopes.CrmEraForce,
    EBrokerScopes.CrmMaxImmo,
    EBrokerScopes.CrmOmnicasa,
    EBrokerScopes.CrmRealSuite,
    EBrokerScopes.CrmSkarabee,
    EBrokerScopes.CrmSweepbright,
    EBrokerScopes.CrmWhise,
    EBrokerScopes.CrmZabun,
];
// cspell:disable
// What each scope actually opens, for the info hover on the key form. Written out rather
// than derived: the guards live in three repos and there is no runtime source the
// backoffice could read. Keep in step with the @CustomScopes / @CrmTokenOnlyScopes
// decorators in rentio-api-next and the accessScopes in rentio-api-legacy.
//
// The resource scopes are v2 only, and that is structural rather than a convention: no
// remote method in rentio-api-legacy declares one, and a v1 method's accessScopes replace
// the implicit DEFAULT, so a custom-scoped key reaches nothing on v1.
export var BROKER_SCOPE_ENDPOINTS = (_a = {},
    _a[EBrokerScopes.ContactsRead] = [
        "GET /v2/contacts",
        "GET /v2/contacts/count",
        "GET /v2/contacts/:id",
    ],
    _a[EBrokerScopes.ContactsWrite] = [
        "POST /v2/contacts",
        "PATCH /v2/contacts/:id",
    ],
    _a[EBrokerScopes.ContractsRead] = [
        "GET /v2/contracts",
        "GET /v2/contracts/count",
        "GET /v2/contracts/:id",
    ],
    _a[EBrokerScopes.ContractsWrite] = [
        "POST /v2/contracts",
        "PATCH /v2/contracts/:id",
    ],
    _a[EBrokerScopes.PropertiesRead] = [
        "GET /v2/properties",
        "GET /v2/properties/count",
        "GET /v2/properties/:id",
    ],
    _a[EBrokerScopes.PropertiesWrite] = [
        "POST /v2/properties",
        "PATCH /v2/properties/:id",
    ],
    _a[EBrokerScopes.PaymentOrdersRead] = [
        "GET /v2/payment-orders",
        "GET /v2/payment-orders/count",
        "GET /v2/payment-orders/:id",
    ],
    _a[EBrokerScopes.PaymentRequestsRead] = [
        "GET /v2/payment-requests",
        "GET /v2/payment-requests/count",
        "GET /v2/payment-requests/:id",
    ],
    _a);
// Every CRM scope opens the same set — the scope says which integration a call came from,
// not what it may do — so they share one list instead of ten identical ones.
export var BROKER_CRM_SCOPE_ENDPOINTS = [
    "POST /v2/properties/external",
    "GET /v2/properties/external/:propertyInfoId",
    "PATCH /v2/properties/external/:propertyInfoId",
    "POST /v2/properties/import",
    "GET /v2/properties/:id",
    "GET /v2/applications/:id/notes",
    "GET /v2/documents/:id",
    "POST /v1/properties/info",
    "GET /v1/properties/info/:propertyInfoId",
    "PATCH /v1/properties/info/:propertyInfoId",
    "PATCH /v1/properties/info/extref/:reference",
    "POST /v1/contacts",
    "GET /v1/contacts/:id",
    "PATCH /v1/contacts/:id",
    "GET /v1/applications/:id",
    "POST /v1/applications/:id/accept",
    "POST /v1/applications/:id/reject",
    "POST /v1/applications/:id/removed",
    "POST /v1/applications/:id/archive",
    "POST /v1/applications/:id/unarchive",
    "POST /v1/applications/:id/duplicate",
    "PUT /v1/applications/:id/step",
];
// Vendor names for the CRM scopes, used to propose a key label. Proper nouns, so they are
// not i18n keys, and spelled out rather than derived from the scope string: capitalizing
// `crm:sweepbright` or `crm:eraforce` gets the internal casing wrong for both vendors.
export var BROKER_CRM_SCOPE_NAMES = (_b = {},
    _b[EBrokerScopes.CrmDewaele] = "Dewaele",
    _b[EBrokerScopes.CrmEraForce] = "EraForce",
    _b[EBrokerScopes.CrmMaxImmo] = "MaxImmo",
    _b[EBrokerScopes.CrmOmnicasa] = "Omnicasa",
    _b[EBrokerScopes.CrmRealSuite] = "RealSuite",
    _b[EBrokerScopes.CrmSkarabee] = "Skarabee",
    _b[EBrokerScopes.CrmSweepbright] = "SweepBright",
    _b[EBrokerScopes.CrmWhise] = "Whise",
    _b[EBrokerScopes.CrmZabun] = "Zabun",
    _b);
// cspell:enable
// How a custom-scoped key's permissions are grouped, so each entity can be ticked as a
// block. Adding a resource to the API adds a block here. The label is an i18n key, not
// copy: this constant is consumed by the mobile app as well as the web backoffice, so the
// consumer resolves it with getLocalizedText.
export var BROKER_SCOPE_GROUPS = [
    {
        labelKey: "broker.api_key.group.properties",
        scopes: [EBrokerScopes.PropertiesRead, EBrokerScopes.PropertiesWrite],
    },
    {
        labelKey: "broker.api_key.group.contracts",
        scopes: [EBrokerScopes.ContractsRead, EBrokerScopes.ContractsWrite],
    },
    {
        labelKey: "broker.api_key.group.contacts",
        scopes: [EBrokerScopes.ContactsRead, EBrokerScopes.ContactsWrite],
    },
    {
        labelKey: "broker.api_key.group.payments",
        scopes: [
            EBrokerScopes.PaymentOrdersRead,
            EBrokerScopes.PaymentRequestsRead,
        ],
    },
];
